
<div class="min-h-screen flex items-center justify-center bg-gray-100">
    <div class="bg-white p-6 rounded-lg shadow-lg text-center">
        <div class="flex justify-center m">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" class="w-12 h-12" id="logout">
                <path fill="#222" d="M32 52.72a20.43 20.43 0 0 1-14.13-35.17 1 1 0 0 1 1.42 0 1 1 0 0 1 0 1.41 18.42 18.42 0 1 0 25.48 0 1 1 0 0 1 0-1.41 1 1 0 0 1 1.42 0A20.43 20.43 0 0 1 32 52.72Z"></path>
                <path fill="#222" d="M32 34a1 1 0 0 1-1-1V12.28a1 1 0 0 1 2 0V33a1 1 0 0 1-1 1Z"></path>
            </svg>
        </div>
      <h3 class="text-lg font-medium text-gray-900">You are logged out successfully</h3>
      <p class="mt-2 text-gray-600">You have been logged out. Please sign in again to continue using our services.</p>
      <button 
      (click)="redirectToLogin()"
      class="mt-4 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">
        Sign-In
      </button>
    </div>
  </div>